const cls = 'evag-snackbar';
const displayTime = 5000;

export const MessageTypes = {
  INFO: 'info',
  DANGER: 'danger',
  SUCCESS: 'success',
  WARNING: 'warning',
  DARK: 'dark',
};

export const displayMessage = function(
  text, type = MessageTypes.INFO, time = displayTime) {
  const body = document.getElementsByTagName('body')[0];
  const element = document.createElement('div');

  element.role = 'alert';
  element.className = `${cls} ${type}`;
  element.style.maxWidth = Math.min(body.offsetWidth - 30, 400) + 'px';

  element.innerHTML = text;

  body.appendChild(element);
  window.setTimeout(() => {
    element.classList.add(`${cls}-shown`);
  }, 0);
  window.setTimeout(() => {
    element.classList.remove(`${cls}-shown`);
  }, time);
  window.setTimeout(() => {
    body.removeChild(element);
  }, time + 1000);
};
